const gtxConstants = require('./gtx-constants');
const gtxLoggedUser = require('./gtx-logged-user');
const beamerSelector = window.innerWidth < 1024 ? '#menu-link-news, #new-menu-link-news' : 'header-link-news'

const beamerInit = function() {
    const productId = gtxConstants('BEAMER_PRODUCT_ID');
    const language = gtxConstants('DEFAULT_LANG');
    const userName = gtxLoggedUser('name');
    const userSurname = gtxLoggedUser('surname');
    const userEmail = gtxLoggedUser('email');
    const idAgent = gtxLoggedUser('idAgente');

    window.beamer_config = {
        product_id : productId,
        selector : beamerSelector,
        display : "right",
        language: language.toUpperCase(),
        filter: 'admin',
        lazy: false,
        alert : true,
        //---------------Visitor Information---------------
        user_id: idAgent,
        user_firstname : userName,
        user_lastname : userSurname,
        user_email : userEmail,
    };
    
    let beamerScriptElement = document.createElement('script');
    beamerScriptElement.src = 'https://app.getbeamer.com/js/beamer-embed.js';
    beamerScriptElement.defer = true;
    document.body.appendChild(beamerScriptElement);
}

exports.beamerInit = beamerInit;
exports.beamerSelector = beamerSelector;
